import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    width: {
      xs: '100%',
      md: 'fit-content',
    },
    borderRadius: '8px',
    display: 'flex',
    overflow: 'hidden',
    border: '1px solid',
    borderColor: 'border.dark',
    backgroundColor: 'background.paper',
    textDecoration: 'none',
    '&:hover .feature-card-cta': {
      textDecoration: 'underline !important',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: { xs: '16px 20px', md: '24px 24px' },
  },
  icon: {
    width: '48px',
    height: '48px',
  },
  defaultCheckIcon: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'green.50',
    flexShrink: 0,
  },
  image: {
    width: '282px',
    height: '312px',
    img: {
      objectFit: 'cover',
    },
    display: { xs: 'none', sm: 'block' },
  },
  rightImage: {},
  description: {
    // ...commonStyles.getLineClampStyles(4, 80),
  },
  button: {
    width: 'fit-content',
    border: 'none',
    typography: 'body3.500',
    backgroundColor: 'transparent',
    '&:hover': {
      border: 'none',
      backgroundColor: 'transparent',
      boxShadow: 'none !important',
    },
    padding: 'unset',
  },
  lightButton: {
    color: 'text.primary',
    textDecoration: 'none',
  },
  darkButton: {
    color: 'common.white',
    textDecoration: 'none',
    ':hover': {
      borderColor: 'common.white',
      boxShadow: '0px 0px 8px white',
    },
  },
  infoWrapper: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
  },
  tagWrapper: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  tag: {
    cursor: 'default',
    height: '28px',
    padding: '4px 12px',
    color: 'text.primaryDark',
    backdropFilter: 'blur(20px)',
    boxShadow: '0px 4px 15px 0px #00000026',
    outline: '1px solid',
  },
  ul: {
    listStyleType: 'disc',
    pl: '10px',
    mt: '-2px',
    color: 'grey.500',
  },
  li: {
    display: 'list-item',
    listStylePosition: 'inside',
    lineHeight: '20px',
  },
  documentWrapper: {
    fontSize: '14px',
  },
  title: {},
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
